import React from "react";
import { Link } from "react-router-dom";
import PopupMenu from "../../../../../Components/PopupMenuThreeDot";
import DeleteIcon from "@mui/icons-material/Delete";
// css comes in AssessPopupBox.css

const DraftActivityPopup = ({
  draftData,
  setDeletePublished,
  activityId,
  setActId,
}) => {
  const actions = [
    {
      label: "Delete",
      onClick: () => {
        setDeletePublished(true);
        setActId(activityId);
      },
      color: "error",
      icon: <DeleteIcon />,
    },
  ];

  return (
    <>
      <PopupMenu actions={actions} />
    </>
  );
};

export default DraftActivityPopup;
